import main from "../scss/main.scss";
import Mmenu from "mmenu-js";
import {createPopper} from "@popperjs/core";
import "bootstrap";

window.bootstrap = require("bootstrap");

import {Fancybox} from "@fancyapps/ui";
import {pl} from "@fancyapps/ui/dist/fancybox/l10n/pl.umd";

const root = document.querySelector("html");
const templateUri = themeData.templateUri;
const appEl = document.querySelector("#app");

//String variables
const playTextScrolling = themeData.play_text_scrolling;
const pauseTextScrolling = themeData.pause_text_scrolling;
const opensInNewTab = themeData.opens_in_new_tab;
const mayOpenInNewTab = themeData.may_open_in_new_tab;
const closeMenu = themeData.close_menu;
const openMenu = themeData.open_menu;
const enableHighContrast = themeData.enable_high_contrast;
const disableHighContrast = themeData.disable_high_contrast;
const uncollapseToSeeMore = themeData.uncollapseToSeeMore;
const collapse = themeData.collapse;
const next = themeData.next;
const prev = themeData.prev;

// Debounce function to limit the frequency of function calls
function debounce(func, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(func, delay);
  };
}

function getCookie(cookieName) {
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  // Return null if the cookie is not found
  return null;
}

window.addEventListener("load", () => {
  const infoModal = document.getElementById("information");
  infoModal.addEventListener("hidden.bs.modal", (event) => {
    document.cookie = encodeURIComponent("modalShowing") + "=" + encodeURIComponent("hide");
  });

  const infoModalBM = new bootstrap.Modal(infoModal);
  if (getCookie("modalShowing") === "hide") {
    return false;
  } else {
    infoModalBM.show();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  appEl.classList.remove("overflow-x-hidden");

  // Mobile menu initialization
  try {
    new Mmenu("#mobileMenu", {
      // options
    }, {
      // configuration
      offCanvas: {
        clone: true, screenReader: {
          closeMenu: closeMenu, openMenu: openMenu,
        }, page: {
          selector: "#app",
        },
      },
    });
  } catch (err) {
    console.log(err);
  }

  // Contrast switching

  const highContrast = document.querySelector(".high-contrast-btn");

  if (highContrast) {
    highContrast.addEventListener("click", function (el) {
      let contrastVal = el.target.getAttribute("data-contrast");
      let contrastLink = document.querySelector(".contrast-link");
      document.cookie = "contrast=" + contrastVal + "; path=/";
      contrastTooltip.dispose();
      if (contrastLink && root.dataset.contrast !== "default") {
        highContrast.setAttribute("data-contrast", "black-on-yellow");
        root.dataset.contrast = contrastVal;
        if (contrastLink) {
          contrastLink.parentNode.removeChild(contrastLink);
          highContrast.setAttribute("aria-label", enableHighContrast);
          highContrast.setAttribute("title", enableHighContrast);
          highContrast.setAttribute("data-bs-tooltip", enableHighContrast);
        }
      } else {
        root.dataset.contrast = contrastVal;
        highContrast.setAttribute("data-contrast", "default");
        if (contrastVal !== "default") {
          let contrastLinkAppend = document.createElement("link");
          contrastLinkAppend.classList.add("contrast-link");
          contrastLinkAppend.setAttribute("rel", "stylesheet");
          contrastLinkAppend.href = templateUri + "/dist/" + contrastVal + ".css";
          document.head.appendChild(contrastLinkAppend);
          highContrast.setAttribute("aria-label", disableHighContrast);
          highContrast.setAttribute("title", disableHighContrast);
          highContrast.setAttribute("data-bs-tooltip", disableHighContrast);
        } else {
          if (contrastLink) {
            contrastLink.remove();
          }
        }
      }
      contrastTooltip = new bootstrap.Tooltip(highContrast);
    });
  }

  var contrastTooltip = new bootstrap.Tooltip(highContrast);

  const checkHighContrast = root.dataset.contrast;
  let contrastVal = root.dataset.contrast;

  if (checkHighContrast == "black-on-yellow") {
    let contrastLinkAppend = document.createElement("link");
    contrastLinkAppend.classList.add("contrast-link");
    contrastLinkAppend.setAttribute("rel", "stylesheet");
    contrastLinkAppend.href = templateUri + "/dist/" + contrastVal + ".css";
    document.head.appendChild(contrastLinkAppend);
    highContrast?.setAttribute("data-contrast", "default");
  }

  // Font size changing

  const fontSizeBtns = document.querySelectorAll(".font-size-btn");

  if (fontSizeBtns) {
    fontSizeBtns.forEach((btn) => {
      btn.addEventListener("click", (el) => {
        let fontSizeVal = el.target.getAttribute("data-font-size");
        root.dataset.fontSize = fontSizeVal;
        document.cookie = "font-size=" + fontSizeVal + "; path=/";
      });
    });
  }

  // Adds 'Opens in new window' tooltip info, excluding AddToAny Buttons

  const targetBlankLinks = document.querySelectorAll('[target="_blank"]:not([class^="a2a_"])');

  targetBlankLinks.forEach((link) => {
    const title = link.getAttribute("title");
    const img = link.querySelector("img");
    const svg = link.querySelector("svg");

    // Check if the link has a title attribute
    if (title !== null) {
      const titleText = title.trim() !== "" ? title : img ? img.getAttribute("alt") : svg ? svg.querySelector("title")?.textContent : "";
      if (titleText) {
        const titleEl = document.createElement("span");
        titleEl.classList.add("visually-hidden");
        titleEl.textContent = titleText;
        link.appendChild(titleEl);
        if (img) img.setAttribute("alt", "");
        if (svg) {
          const svgTitle = svg.querySelector("title");
          if (svgTitle) svgTitle.remove();
          svg.setAttribute("role", "presentation");
          svg.setAttribute("aria-hidden", "true");
        }
      }
    }
    link.title = opensInNewTab;
    link.setAttribute("data-bs-toggle", "tooltip");
  });

  // Initialize tooltips
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      container: "body",
    });
  });

  /* add fancybox into gallery images */
  const galleryItems = document.querySelectorAll(".wp-block-gallery a");
  const imageItems = Array.from(document.querySelectorAll("figure.wp-block-image a")).filter((el) => !el.closest(".wp-block-gallery"));

  if (galleryItems) {
    galleryItems.forEach((elem) => {
      elem.setAttribute("data-fancybox", "gallery");
    });
  }

  const galleryElements = document.querySelectorAll(".gallery a");
  if (galleryElements) {
    galleryElements.forEach((elem) => {
      elem.setAttribute("data-fancybox", "gallery");
    });
  }

  if (imageItems) {
    imageItems.forEach((elem) => {
      elem.setAttribute("data-fancybox", "data-fancybox");
    });
  }

  Fancybox.bind("[data-fancybox]", {
    on: {
      done: function (instance, current) {
        current.imageEl.setAttribute("alt", current.triggerEl.querySelector("img").getAttribute("alt"));
        document.querySelectorAll(".fancybox-focus-guard").forEach((el) => {
          el.removeAttribute("aria-hidden", "false");
          el.removeAttribute("aria-label");
        });
      },
    }, l10n: pl, Toolbar: {
      display: {
        left: [""], right: ["close"],
      },
    }, autofocus: true, Thumbs: false,
  });

  // Fix role=dialog for nav wcag
  const navRoleDialogs = document.querySelectorAll('nav[role="dialog"]');

  if (navRoleDialogs) {
    navRoleDialogs.forEach((el) => {
      el.setAttribute("role", "navigation");
    });
  }

  // Fix aria-modal for nav wcag
  const navRoleAriaModals = document.querySelectorAll('nav[aria-modal="true"]');

  if (navRoleAriaModals) {
    navRoleAriaModals.forEach((el) => {
      el.removeAttribute("aria-modal");
    });
  }

  /* Cookies Policy - WCAG Fix  for https://pl.wordpress.org/plugins/cookie-law-info/*/
  const cookiesSettingsBtn = document.querySelector(".cli_settings_button");
  if (cookiesSettingsBtn) {
    cookiesSettingsBtn.setAttribute("tabindex", "0");
    cookiesSettingsBtn.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        e.target.click();
        document.querySelector(".cli-modal-close").focus();
      }
    });
  }

  const cookiesActionBtn = document.querySelector(".cli_action_button");
  if (cookiesActionBtn) {
    cookiesActionBtn.setAttribute("tabindex", "0");
  }

  const cookieRejectBtn = document.querySelector("#cookie_action_close_header_reject");

  if (cookieRejectBtn) {
    cookieRejectBtn.setAttribute("tabindex", "0");
  }

  // Move cookie elements to footer

  const cookieBar = document.querySelector("#cookie-law-info-bar");
  const cookieBarAgain = document.querySelector("#cookie-law-info-again");
  const footer = document.querySelector(".main-footer");
  if (cookieBar) {
    footer.appendChild(cookieBar);
  }
  if (cookieBarAgain) {
    footer.appendChild(cookieBarAgain);
  }

  const cliModal = document.querySelector(".cli-modal");

  if (cliModal) {
    const modalTitle = cliModal.querySelector(".cli-privacy-overview h4");
    modalTitle.outerHTML = "<h3>" + modalTitle.textContent + "</h3>";
    footer.appendChild(cliModal);
  }

  const privacyOverview = document.querySelector(".cli-privacy-overview h3");

  if (privacyOverview) {
    privacyOverview.textContent = "Przegląd polityki prywatności";
  }

  // Responsive tables
  const tables = document.querySelectorAll("table");

  if (tables.length) {
    tables.forEach(function (table) {
      const tableWrapper = document.createElement("div");
      tableWrapper.classList.add("table-responsive");
      table.classList.add("table");
      table.parentNode.insertBefore(tableWrapper, table);
      tableWrapper.appendChild(table);
    });
  }

  //Notifications scrollbar

  const scrollbarBtn = document.querySelector(".notificationsBtn");

  if (scrollbarBtn) {
    const scrollContent = document.querySelector(".notifications");
    const scrollbarBtnIcon = scrollbarBtn.querySelector(".icon");

    scrollbarBtn.addEventListener("click", (e) => {
      scrollContent.classList.toggle("paused");
      if (!scrollbarBtnIcon.contains(e.target)) {
        e.stopPropagation();
      }

      const currentAria = e.target.getAttribute("aria-label");
      const toggleAria = currentAria === pauseTextScrolling ? playTextScrolling : pauseTextScrolling;
      e.target.setAttribute("aria-label", toggleAria);
      e.target.classList.toggle("paused");
    });
  }

  const showIconsBtn = document.querySelector(".btn-showIcons");

  if (showIconsBtn) {
    showIconsBtn.addEventListener("click", (e) => {
      const menuAbout = document.querySelector("#iconMenuAbout ul");
      menuAbout.classList.toggle("showAllIcons");
      let textBtn = showIconsBtn.textContent;
      showIconsBtn.textContent = textBtn === uncollapseToSeeMore ? collapse : uncollapseToSeeMore;

      let ariaExpanded = showIconsBtn.getAttribute("aria-expanded");
      showIconsBtn.setAttribute("aria-expanded", ariaExpanded === "true" ? "false" : "true");
    });
  }

  // Toggle search field

  const searchCollapse = document.getElementById("searchCollapse");
  searchCollapse.addEventListener("shown.bs.collapse", () => {
    searchCollapse.querySelector(".main-search-field").focus();
  });

  const searchCollapseMobile = document.getElementById("searchMobileCollapse");
  searchCollapseMobile.addEventListener("shown.bs.collapse", () => {
    searchCollapseMobile.querySelector(".main-search-field").focus();
  });

  // Toggle Project Implementation

  const prjToogleBtns = document.querySelectorAll(".collapseToggle a");

  if (prjToogleBtns) {
    prjToogleBtns.forEach((btn) => {
      btn.setAttribute("role", "button");
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("data-bs-toggle", "collapse");
      btn.setAttribute("aria-controls", btn.getAttribute("href").slice(1));
    });
  }

  //Submenu positioning

  function adjust2ndSubmenuPosition() {
    const subMenus = document.querySelectorAll(".mega-menu .mega-sub-menu .mega-sub-menu");

    if (subMenus.length) {
      subMenus.forEach(function (submenu) {
        const parentItem = submenu.closest(".mega-menu-item");
        const parentRight = parentItem.getBoundingClientRect().right;
        const submenuWidth = submenu.offsetWidth;
        const viewportWidth = window.innerWidth;

        if (parentRight + submenuWidth > viewportWidth) {
          submenu.style.left = "auto";
          submenu.style.right = "100%";
        } else {
          submenu.style.left = "100%";
          submenu.style.right = "auto";
        }
      });
    }
  }

  function adjust1stSubmenuPosition() {
    const subMenus = document.querySelectorAll(".mega-menu > li > .mega-sub-menu");

    if (subMenus.length) {
      subMenus.forEach(function (submenu) {
        const parentItem = submenu.closest(".mega-menu-item");
        const parentRight = parentItem.getBoundingClientRect().right;
        const submenuWidth = submenu.offsetWidth;
        const viewportWidth = window.innerWidth;

        if (parentRight + submenuWidth > viewportWidth) {
          submenu.style.left = "auto";
          submenu.style.right = "0";
        } else {
          submenu.style.left = "0";
          submenu.style.right = "auto";
        }
      });
    }
  }

  adjust1stSubmenuPosition();
  adjust2ndSubmenuPosition();

  const debouncedFunctions = debounce(function () {
    adjust1stSubmenuPosition();
    adjust2ndSubmenuPosition();
  }, 250);

  window.addEventListener("resize", debouncedFunctions);
});

//menu sidebar
document.addEventListener("DOMContentLoaded", () => {
  const sidebarMenu = document.querySelector(".sidebarMenu ul");
  if (sidebarMenu) {
    const separatorList = sidebarMenu.querySelectorAll(".separator");
    separatorList.forEach((item, index) => {
      const panelId = `panel-${index}`;
      item.setAttribute("aria-controls", panelId);
      item.nextElementSibling.id = panelId;

      const toggleVisibility = () => {
        item.ariaExpanded = item.ariaExpanded !== "true";
        item.nextElementSibling.classList.toggle("is-visible");
      };

      item.addEventListener("click", toggleVisibility);
      item.addEventListener("keypress", (event) => {
        if (event.key === "Enter") {
          toggleVisibility();
        }
      });
    });

    let currentItem = sidebarMenu.querySelector('.current-menu-ancestor');
    if (currentItem) {
      currentItem.querySelector('.sub-menu').classList.add('is-visible');
      currentItem.querySelector('button.separator').ariaExpanded = "true";

      let secondSubmenu = currentItem.querySelector('.sub-menu');
      if (secondSubmenu) {
        secondSubmenu.querySelector('.sub-menu').classList.add('is-visible');
        secondSubmenu.querySelector('button.separator').ariaExpanded = "true";
      }
    }
  }
});
